<route-report-modal [modalId]="modalId" [title]="title" [state]="state"
  (closing)="closing.emit()" (closed)="closed.emit()" (retry)="retry.emit()" (rowAction)="rowAction.emit($event)">
</route-report-modal>
